import { render, staticRenderFns } from "./FooterApp.vue?vue&type=template&id=fc9387dc&scoped=true"
import script from "./FooterApp.vue?vue&type=script&setup=true&lang=js"
export * from "./FooterApp.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FooterApp.vue?vue&type=style&index=0&id=fc9387dc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc9387dc",
  null
  
)

export default component.exports